import React, { FC } from "react";
import ReusableAccordian from "../ReusableAccordion";
import SizeLayout from "../SizeLayout";
import PleaseNote from "../PleaseNote";
import { Typography } from "@mui/material";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import useWidthSelection from "./useWidthSelection";

const StyledTypography = styled(Typography)({
  fontSize: 20,
  fontWeight: "bold",
  paddingRight: 40,
  width: 250
});

const BifoldComboUnitSizeAccordian: FC = () => {
  const {
    handleWidthChangeDoor,
    handleFractionChangeDoor,
    handleFractionChangeWindow,
    handleWidthChangeWindow,
    widthErrWindow,
    widthErrDoor,
    doorWidth,
    windowWidth,
    doorWidthFraction,
    windowWidthFraction,
    overallWidth
  } = useWidthSelection();

  return (
    <ReusableAccordian
      accordionName="unitSize"
      heading="Net Frame Width"
      secondaryHeading=" Select a Width"
      required5={true}
      colOrRow="col"
    >
      <PleaseNote notes="We recommend each Net Frame Width to be 1/2 inch less than the Rough Opening Width" />

      {overallWidth !== 0 && (
        <RowLayout style={{paddingTop: 10}}>
          <Typography style={{ fontWeight: "bold", paddingRight: 10 }}>Overall Net Width: </Typography>
          <Typography>{overallWidth}"</Typography>
        </RowLayout>
      )}

      <RowLayout>
        <ColLayout style={{ marginRight: 40 }}>
          <RowLayout>
            <StyledTypography>Door Net Width:</StyledTypography>
            <SizeLayout
              size={doorWidth || ""}
              handleChange={handleWidthChangeDoor}
              sizeErr={widthErrDoor}
              name="width"
              fractionValue={doorWidthFraction || ""}
              handleFractionChange={handleFractionChangeDoor}
            />
          </RowLayout>
          <RowLayout>
            <StyledTypography>Window Net Width:</StyledTypography>
            <SizeLayout
              size={windowWidth || ""}
              handleChange={handleWidthChangeWindow}
              sizeErr={widthErrWindow}
              name="width"
              fractionValue={windowWidthFraction || ""}
              handleFractionChange={handleFractionChangeWindow}
            />
          </RowLayout>
        </ColLayout>
      </RowLayout>
    </ReusableAccordian>
  );
};

export default BifoldComboUnitSizeAccordian;
